import { Node, NodeViewWrapper, ReactNodeViewRenderer } from '@tiptap/react';
import { useState, useEffect, useRef } from 'react';
import { getAllProductCategory } from '../../../../../api/productCategoriesApi';

const CategoryBlockView = (props) => {
    const { node, updateAttributes } = props;
    const categories = node.attrs.categories || [];
    const dropdownRef = useRef(null)

    const [allCategories, setAllCategories] = useState([]);
    const [selectedCategories, setSelectedCategories] = useState(categories);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target)
            ) {
                setIsDropdownOpen(false)
            }
        }

        document.addEventListener('mousedown', handleClickOutside)
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [])

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const response = await getAllProductCategory();
                setAllCategories(response?.data?.data || []);
            } catch (error) {
                console.error('Error fetching categories:', error);
            }
        };
        fetchCategories();
    }, []);

    const handleSelectCategory = (category) => {
        setSelectedCategories(prev => {
            const isSelected = prev.find(c => {return Number(c?.categoryId) === Number(category?.categoryId)});
            if (isSelected) {
                return prev.filter(c => {return Number(c.categoryId) !== Number(category.categoryId)});
            } else {
                return [...prev, category];
            }
        });
    };

    const handleApply = () => {
        updateAttributes({ categories: selectedCategories });
    };

    const renderCategoryItem = (category) => (
        <div key={category.categoryId} className='category-item' data-category={category.categoryId} data-image={category?.image?.key}>
            <p className='heading'>{category?.name}</p>
            <img src={category?.image?.url || '/default-category.png'} alt={category.name} />
            <a href={`/product-category/${category?.parentSlug}/${category?.slug}`} className='category-link'>{category?.isServiceProduct === true ? "Order Now" : "Shop Now"}</a>
        </div>
    );

    return (
        <NodeViewWrapper data-type="categoryBlock">
            <div className='category-wrapper'>
                <div className='category-selector'>
                    <div className="dropdown-wrapper" ref={dropdownRef}>
                        <div className="dropdown-header" onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
                            <span className="title">Select Categories ({selectedCategories.length})</span>
                        </div>
                        {isDropdownOpen && (
                            <div className="dropdown-list">
                                {allCategories?.map(category => {
                                
                                    return (<label key={category.categoryId} className="dropdown-item" onClick={() => handleSelectCategory(category)}>
                                        <input
                                            type="checkbox"
                                            checked={selectedCategories.some(c => Number(c?.categoryId) === Number(category?.categoryId))}
                                            onChange={() => handleSelectCategory(category)}
                                        />
                                        {category?.name}
                                    </label>)
                                })}
                            </div>
                        )}
                    </div>
                    <button className='save-btn' onClick={handleApply}>Apply category</button>
                </div>
                {categories.length > 0 && (
                    <div className='category-display'>
                        <div className='category-grid-wrapper'>
                            {categories.slice(0, 4)?.map((category, index) => renderCategoryItem(category))}
                        </div>
                    </div>
                )}
            </div>
        </NodeViewWrapper>
    );
};

export const CategoryBlock = Node.create({
    name: 'categoryBlock',

    group: 'block',

    defining: true,

    isolating: true,

    addAttributes() {
        return {
            categories: {
                default: [],
            },
        };
    },

    parseHTML() {
        return [
            {
                tag: `div[data-type="${this.name}"]`,
                getAttrs: (element) => {
                    const categoryItems = element.querySelectorAll('.category-item');
                    const categories = Array.from(categoryItems).map(item => {
                        const categoryId = item.getAttribute('data-category');
                        const imageKey = item.getAttribute('data-image');
                        const name = item.querySelector('h4')?.textContent || item.querySelector('p.heading')?.textContent;
                        const img = item.querySelector('img');
                        const link = item.querySelector('a.category-link');
                        const slug = link ? link.getAttribute('href')?.replace('/product-category/', '') : null;
                        return {
                            categoryId,
                            name,
                            image: imageKey ? { key: imageKey, url: img?.src } : img ? { url: img.src } : null,
                            slug,
                            isServiceProduct: item.getAttribute('data-is-service') === 'true',
                        };
                    });
                    return { categories };
                },
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        const categories = HTMLAttributes.categories || [];
        return [
            'div',
            { 'data-type': this.name, class: 'category-block' },
            ...categories?.map(cat => [
                'div',
                { class: 'category-item', 'data-category': cat?.categoryId, 'data-image': cat?.image?.key, 'data-is-service': cat?.isServiceProduct, },
                ['h4', cat.name],
                [
                    'img',
                    { src: cat?.image?.url || '/default-category.png', alt: cat.name }
                ],
                cat.slug ? ['a', { href: `/product-category/${cat?.parentSlug}/${cat.slug}`, class: 'category-link' }, (cat?.isServiceProduct === true) ? 'Order Now' : 'Shop Now'] : null
            ].filter(Boolean))
        ];
    },

    addCommands() {
        return {
            setCategoryBlock:
                (options) =>
                    ({ commands }) => {
                        return commands.insertContent({
                            type: this.name,
                            attrs: {
                                categories: options?.categories || [],
                            },
                        });
                    },
        };
    },

    addNodeView() {
        return ReactNodeViewRenderer(CategoryBlockView);
    },
});